import { Http } from "../utils/http.js";
class Common extends Http {
  addUserLike(param) {
    let _this = this;
    return _this.request({
      url: "/WebApi/Customer/AddUserLike",
      method: "post",
      param: param
    });
  }
  searchAll(param) {
    let _this = this;
    return _this.request({
      url: "/WebApi/OpenPage/SearchAll",
      method: "post",
      param: param
    });
  }
}
export { Common };
